export function hydrateControlServers(cs, jq, rs, us) {
  return cs.map(c => Object.assign({}, c, {
    jobQueue: jq.find(q => q.controlServer?.id === c.id),
    lockedBy: (c.lockedBy?.id) ? us.find(u => u.id === c.lockedBy.id) : null,
    reservations: rs.filter(r => r.controlServer?.id === r.id).map(r => {
      return Object.assign({}, r, {recipient: us.find(u => u.id === r.recipient.id)});
    })
  }));
}
